import React, { useEffect, useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Snackbar,
  Typography
} from '@mui/material';
import { themeColors } from '@ianesthesie-kit/config';
import { useAppDispatch, useShallowAppSelector } from '@/hooks';
import {
  clearNewPatientSnackbar,
  selectNewPatientSnackbar
} from '@/modules/ui';
import { FormattedMessage } from 'react-intl';
import { OpenInNewIcon } from '@/components/icon';
import { useLocale, TranslatedText } from '@ianesthesie-kit/core';

export const PatientCreatedSnackbar = () => {
  const dispatch = useAppDispatch();
  const locale = useLocale();
  const snackbarData = useShallowAppSelector(selectNewPatientSnackbar);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (snackbarData) {
      setOpen(true);
    }
  }, [snackbarData]);

  const closeSnackbar = () => {
    setOpen(false);
  };

  const onTransitionEnd = () => {
    if (!open) {
      dispatch(clearNewPatientSnackbar());
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={closeSnackbar}
      autoHideDuration={5000}
      TransitionProps={{
        onExited: onTransitionEnd
      }}
    >
      <Alert
        elevation={5}
        onClose={closeSnackbar}
        severity="success"
        variant="filled"
        sx={{
          width: '100%',
          color: themeColors.slate[100],
          '& *': { overflow: 'visible!important' }
        }}
      >
        <AlertTitle>
          <FormattedMessage
            id="doctor-dashboard.snackbar.patientCreated.title"
            values={{ patientName: snackbarData?.name }}
          />
        </AlertTitle>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
        >
          <Typography variant="body2">
            <TranslatedText id="doctor-dashboard.snackbar.patientCreated.subtitle" />
          </Typography>
          {!!snackbarData?.id && (
            <Button
              href={`/${locale}/patients/${snackbarData.id}`}
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
              size="small"
              onClick={closeSnackbar}
              sx={{
                color: themeColors.blue[600],
                position: 'relative',
                left: 40,
                zIndex: 2,
                textDecoration: 'none',
                pt: 0,
                pb: 0,
                '& svg': {
                  width: 16,
                  height: 16
                }
              }}
              endIcon={<OpenInNewIcon />}
            >
              <TranslatedText id="app.open" />
            </Button>
          )}
        </Box>
      </Alert>
    </Snackbar>
  );
};
